<button
  class="projectPicker"
  mat-button
  data-cy="project-picker-menu-button"
  [matMenuTriggerFor]="projectPickerMenu"
  [disabled]="disabled()"
  (click)="onMenuTriggered()">
  <div class="d-flex w-100 align-items-center text-truncate">
    <span class="text-truncate" [title]="selectedProject()?.name">{{ selectedProject()?.name }}</span>

    @if (selectedProject()?.logoUrl) {
      <img class="projectPicker_logo ms-auto ps-2" alt="Project picker logo" [src]="selectedProject()?.logoUrl" />
    } @else {
      <ng-container>
        <span class="ms-auto">&nbsp;</span>
      </ng-container>
    }

    <mat-icon class="iconRight" svgIcon="menu-down" />
  </div>
</button>

<mat-menu #projectPickerMenu="matMenu" class="mt-2 navbarMenuPanel">
  @for (project of projects() | sort: 'name'; track $index) {
    <button
      mat-menu-item
      class="projectPicker_item"
      [ngClass]="{ 'selectedProject': project.id === selectedProjectId() }"
      [attr.data-cy]="`project-picker-${project.name | dataCySlug}-menu-item`"
      (click)="onProjectChange(project)">
      <div class="d-flex w-100 align-items-center text-truncate">
        <span class="text-truncate" [title]="project.name">{{ project.name }}</span>

        @if (project?.logoUrl) {
          <img class="projectPicker_logo ms-auto ps-1" [src]="project?.logoUrl" [alt]="project?.name" />
        } @else {
          <ng-container>
            <span class="ms-auto">&nbsp;</span>
          </ng-container>
        }
      </div>
    </button>
  }
</mat-menu>
